export default __webpack_public_path__ + "static/arung-4a739df540bbb7b2d04c8f7f3acb2481.webp";